
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";


const firebaseConfig = {
  apiKey: "AIzaSyCcvD-AtIGBcv_xBTSe_-noKDXp-C755Ro",
  authDomain: "helpdesk-577a1.firebaseapp.com",
  projectId: "helpdesk-577a1",
  storageBucket: "helpdesk-577a1.firebasestorage.app",
  messagingSenderId: "27586068736",
  appId: "1:27586068736:web:d4266781c0c3ae234073e5",
  measurementId: "G-G4BFNEH500"
};

const app = initializeApp(firebaseConfig);

// Initialize messaging only in browser
let messaging = null;
if (typeof window !== "undefined") {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn("Firebase Messaging initialization failed:", error);
  }
}

export { app, messaging };
